<!-- 产品详情 -->
<template>
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">{{ detail.equipmentTitle }}</div>
    </div>

    <div class="display_flex productBox">
      <OssImg :src="detail.equipmentHeaderOssUrl" alt="" />
      <div class="info" v-html="detail.equipmentRemark?.replace(/\/n/g, '<br/>')">
      </div>
    </div>

    <div class="imageBox">
      <OssImg
        :src="item"
        class="imageItem"
        alt=""
        v-for="(item, index) in detail.equipmentOssUrl"
        :key="index"
      />
    </div>

    <div class="title" style="text-align: center">
      <div class="text1">产品详情</div>
    </div>
    <div class="display_flex infoBox">
      <OssImg :src="detail.equipmentHeaderOssUrl" alt="" />
      <div class="richTextCl" v-html="detail.equipmentDetail">
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ProductApi from '@/api/productApi';
import OssImg from "@/components/ossImg.vue";
import { processRichTextImages } from "@/utils/hanldeRichText";
const productApi = new ProductApi();
const route = useRoute();
const id = ref(0);
const detail = ref({});

onMounted(() => {
  id.value = route.query.id;
  getDetail(id.value)
  addDeviceBrower(id.value)
});

const getDetail = async (id) => {
  console.log('id-----------',id)
  let res = await productApi.getDeviceDetail(id);
  let equipmentOssUrl = res.data.equipmentOssUrl;
  if(!equipmentOssUrl){
    equipmentOssUrl = '';
  }

  if(!equipmentOssUrl?.includes(',')){
    equipmentOssUrl = equipmentOssUrl+',';
  }
  equipmentOssUrl = equipmentOssUrl.split(',');
  detail.value = res.data;
  detail.value.equipmentOssUrl = equipmentOssUrl;
  detail.value.equipmentDetail  = await processRichTextImages(detail.value.equipmentDetail)
  console.log('detail.value',detail.value)
};

/**
 * 设备详情浏览量增加
 */
const addDeviceBrower = async(id)=>{
  await productApi.addDeviceBrowse(id)
}
</script>

<style lang="scss" scoped>
.productBox {
  img {
    width: 60% !important;
    height: 100%;
    max-height: 634px;
    object-fit: contain;
  }

  .info {
    width: 40%;
    padding: 3rem;
    color: #424242;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.75rem;
    line-height: 2.5rem;
  }
}

.infoBox{
  width: 100%;
  img {
    width: 50% !important;
    height: 100%;
    max-height: 700px;
    object-fit: contain;
    margin-right: 2rem;
  }

  div{
    width: 50%;
  }
}

.imageBox {
  margin-top: 2rem;

  .imageItem {
    width: 100%;
    margin-bottom: 1rem;
    max-height: 34.375rem;
    object-fit: contain;
  }
}
</style>
